<template>
	<div v-if="locale == 'nl'" class="newsletter-parent">
		<h3>{{ header }}</h3>
		<div v-parse-links v-html="content" />
		<div class="newsletter-wrapper">
			<div class="newsletter-toggle">
				<div :class="{ active: activeType === 'business' }" @click="() => setActiveType('business')">
					<div class="toggle-icon" />
					<span>{{ $t('newsletterBusiness') }}</span>
				</div>
				<div :class="{ active: activeType === 'leisure' }" @click="() => setActiveType('leisure')">
					<div class="toggle-icon" />
					<span>{{ $t('newsletterLeisure') }}</span>
				</div>
			</div>

			<ClientOnly>
				<form
					method="post"
					action="https://de-baak-hospitality.email-provider.eu/subscribe/post/index.php"
					:class="['form-' + types[activeType].formClass, 'newsletter']"
				>
					<input type="hidden" name="next" :value="`${config.public.siteUrl}/nieuwsbrief-aanmelding`" />
					<input type="hidden" name="a" value="kfbqebukmq" />
					<input type="hidden" name="l" :value="types[activeType].formClass" />
					<input
						:id="'id-' + types[activeType].inputId"
						:name="types[activeType].inputId"
						:placeholder="$t('formEmail')"
						autocomplete="email"
						type="email"
						required
					/>
					<input
						id="email"
						autocomplete="new-password"
						type="email"
						name="email"
						placeholder="Your e-mail here"
						style="position: absolute; top: -9999px; left: -9999px"
					/>
					<input type="submit" class="button" :value="button" />
				</form>
			</ClientOnly>
		</div>
	</div>
	<div v-else-if="locale == 'de'" class="newsletter-parent">
		<h3>{{ header }}</h3>
		<div v-parse-links v-html="content" />
		<div class="newsletter-wrapper">
			<ClientOnly>
				<form
					method="post"
					action="https://de-baak-hospitality.email-provider.eu/subscribe/post/index.php"
					class="form-sj6elr4uho newsletter"
				>
					<input type="hidden" name="next" :value="`${config.public.siteUrl}/newsletter-anmeldung`" />
					<input type="hidden" name="a" value="kfbqebukmq" />
					<input type="hidden" name="l" value="3ephanzw97" />
					<input
						id="id-ZeroGOsWs7"
						name="ZeroGOsWs7"
						:placeholder="$t('formEmail')"
						autocomplete="email"
						type="email"
						required
					/>
					<input
						id="email"
						autocomplete="new-password"
						type="email"
						name="email"
						placeholder="Your e-mail here"
						style="position: absolute; top: -9999px; left: -9999px"
					/>
					<input type="submit" class="button" :value="button" />
				</form>
			</ClientOnly>
		</div>
	</div>
</template>

<script setup>
const { locale } = useI18n();
const config = useRuntimeConfig();

const activeType = ref('business');

const types = ref({
	business: {
		formClass: '0uplgf5b4j',
		inputId: '5SbDnXVWXc',
	},
	leisure: {
		formClass: '3ephanzw97',
		inputId: 'zWWuxEIkMc',
	},
});

const setActiveType = (type) => {
	if (typeof types.value[type] === 'undefined') {
		throw new Error('Invalid newsletter type');
	}

	activeType.value = type;
};

defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});

useHead({
	script: [
		{
			src: 'https://de-baak-hospitality.email-provider.eu/subscribe/check/validate.js',
		},
	],
});
</script>

<style lang="scss" scoped>
.newsletter {
	flex-flow: row wrap;

	input {
		appearance: none;
		border-radius: 50px 0 0 50px;
	}

	input:not(.button) {
		color: var(--body-color);
		border: none;
		width: 58%;
		padding: 0 20px;
		line-height: 50px;
		height: 50px;
		outline: none !important;
		font-size: 15px;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
		width: 42%;
		height: 50px;
		border-radius: 0 50px 50px 0;
		font-size: 15px;
		background: var(--body-color);
		padding: 9px 0;
		text-align: center;
	}
}

.newsletter-toggle {
	display: flex;
	flex-flow: row wrap;
	margin: 0 0 20px;

	div {
		display: flex;
		flex-flow: row nowrap;
		margin: 0 20px 0 0;
		cursor: pointer;

		.toggle-icon {
			width: 15px;
			height: 15px;
			border-radius: 50%;
			border: 1px solid var(--body-color);
			margin: -1px 5px 1px 0;
			position: relative;

			&::before {
				content: '';
				display: block;
				width: 9px;
				height: 9px;
				inset: 2px;
				border-radius: 50%;
				position: absolute;
			}
		}

		&.active {
			.toggle-icon::before {
				background: var(--body-color);
			}
		}
	}
}

h3 {
	color: var(--body-color);
	font-weight: 400;
}

/* client side validation */
.form-3ephanzw97 input:invalid {
	border: 2px dashed red;
}

.form-3ephanzw97 input:invalid:required {
	border: 0 solid #ccc;
}

.form-3ephanzw97 input:valid {
	border: 0 solid #ccc;
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100%;
		text-align: center;
	}
}
</style>
